import React, { Fragment } from "react";
import { Link, useMatches } from "react-router";
import { useTranslation } from "react-i18next";

interface BreadcrumbMatch {
  pathname: string;
  params: Record<string, string | undefined>;
  handle?: { breadcrumb?: string };
}

export const BreadcrumbsComponent = () => {
  const matches = useMatches() as BreadcrumbMatch[];
  const { t } = useTranslation();

  const breadcrumbs = matches.filter((m) => m.handle?.breadcrumb);
  if (breadcrumbs.length === 0) return null;

  const currentPathname = matches[matches.length - 1]?.pathname || "";

  return (
    <>
      {breadcrumbs.map((match, index) => {
        const isCurrentPage = match.pathname === currentPathname;
        const label = t(match.handle!.breadcrumb!);
        const version = isCurrentPage ? match.params.version : undefined;
        const text = version ? `${label} V${version}` : label;

        return (
          <Fragment key={match.pathname}>
            {isCurrentPage ? (
              <>{text}</>
            ) : (
              <Link to={match.pathname}>{text}</Link>
            )}
            {index < breadcrumbs.length - 1 && <> / </>}
          </Fragment>
        );
      })}
    </>
  );
};
